<template>
  <!-- <div class="page-header align-items-start min-vh-100" v-if="isWaitingTime">
    <div class="merchant-logo"> -->
      <!-- <img
        src="@/assets/img/logos/WH_Logo.gif"
        class="avatar-md border-radius-lg"
        alt="logo"
        height="240"
      /> -->
    <!-- </div>
    <div class="container p-0">
      <div class="row justify-content-center">
        <div class="text-center">
          <div
            class="font-weight-bolder outlet-name"
          >
            {{ branch.branch_name }}
          </div>
          <div class="estimated-waiting-time">
            Estimated Waiting Time
          </div>
          <div class="estimated-waiting-time" v-if="branch.waiting_time_text">
            {{ branch.waiting_time_text }}
          </div>
        </div>
        <material-button class="btn btn-start-ordering" @click="gotoSlide()">START ORDERING</material-button>
      </div>
    </div>
  </div> -->
  <!-- SH001: the branch's "Theme for Salon" setting swaps this landing for the salon
       booking flow. Everything below stays exactly as it is for every other branch.
       SH002: the flow is now several steps, so it renders through its own container. -->
  <SalonBookingFlow v-if="isSalonTheme" />
  <!-- MTH009: theme2 reskin — landing hero carousel (mobile frame) -->
  <div
    v-if="!isSalonTheme && !loaderActive && showLandingPage"
    class="mlx-landing"
    :style="[styleObject, { '--mlx-accent': loaderAccent }]"
    @click="gotoCategory()"
  >
    <div class="mlx-landing-hero">
      <swiper
        v-if="slidesLandingPage.length"
        class="mlx-landing-swiper"
        :slides-per-view="1"
        :space-between="0"
        :loop="slidesLandingPage.length > 1"
        :autoplay="{
          delay: 3000,
          disableOnInteraction: false,
        }"
        :pagination="{
          clickable: true,
          el: '.mlx-landing-pagination',
        }"
      >
        <swiper-slide v-for="(value, index) in slidesLandingPage" :key="index">
          <img class="mlx-landing-img" :src="value.file_url" alt="" />
        </swiper-slide>
        <!-- <swiper-slide>
          <div class="slider">
            <img
              src="@/assets/img/cover-image-1.png"
              alt="error"
            />
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slider">
            <img
              src="@/assets/img/cover-image-2.png"
              alt="error"
            />
          </div>
        </swiper-slide> -->
      </swiper>
      <div
        v-else
        class="mlx-landing-fallback"
        :style="`background: linear-gradient(160deg, ${loaderAccent} 0%, #201a1a 100%);`"
      ></div>
      <div class="mlx-landing-overlay"></div>
      <div class="mlx-landing-brand">
        <div class="mlx-landing-logo"><img :src="loaderLogo" alt="Logo" /></div>
        <span v-if="brandName" class="mlx-landing-brand-name">{{ brandName }}</span>
      </div>
      <div class="mlx-landing-pagination"></div>
      <div class="mlx-landing-cta">
        <material-button
          class="mlx-landing-btn"
          fullWidth
          :style="`background: ${buttonColorTheme2} !important; color: #fff !important;`"
          >Order now</material-button
        >
      </div>
    </div>
  </div>
  <VoucherAvailable v-if="!isSalonTheme" />
  <!-- MTH004: branded login-callback loader (theme2) -->
  <div v-if="isLoggingIn" class="mlx-login-loader" :style="{ '--mlx-accent': loaderAccent }">
    <div class="mlx-ll-logo"><img :src="loaderLogo" alt="Logo" /></div>
    <div v-if="brandName" class="mlx-ll-brand">{{ brandName }}</div>
    <div class="mlx-ll-spinner"></div>
    <div class="mlx-ll-text">Signing you in…</div>
  </div>
  <material-loading :active="loaderActive && !isLoggingIn" />
</template>

<script>
import { mapMutations } from "vuex";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import MaterialButton from "@/components/MaterialButton.vue";
import router from "@/router";
import CryptoJS from 'crypto-js';
import TokenService from "../services/token.service";
import AuthService from "../services/auth.service";
import VoucherAvailable from "@/common/VoucherAvailable/VoucherAvailable";
// import $ from "jquery";
import MaterialLoading from '@/components/MaterialLoading.vue';
import OrderService from "../services/order.service";
import { localStorageName } from '@/config/utils';
import { QR_REDIRECT_LANDING_PAGE } from '@/config/const';
import defaultLogo from "@/assets/img/logo.png";
import SalonBookingFlow from "@/salon/views/BookingFlow.vue";

SwiperCore.use([Pagination]);

export default {
  name: "Cover",
  components: {
    Swiper,
    SwiperSlide,
    MaterialButton,
    VoucherAvailable,
    MaterialLoading,
    SalonBookingFlow
  },
  data() {
    return {
      loaderActive: false,
      isLoggingIn: false,
      message: "",
      snackbar: null,
      isWaitingTime: true,
      prefixUrl: "",
      branch: JSON.parse(localStorage.getItem(localStorageName('BRANCH_INFO'), '')),
      merchantCode: "",
      branchCode: "",
      slidesLandingPage: [],
      memberInfo: JSON.parse(localStorage.getItem(localStorageName('memberInfo'), '')),
    };
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  async created() {
    // Set merchant/branch in Vuex immediately from route params so localStorageName()
    // and child-page store reads are correct before checkMerchantAndBranch() responds.
    if (this.$route.params.merchant_code) {
      await this.$store.dispatch('setMerchantCode', this.$route.params.merchant_code);
    }
    if (this.$route.params.branch_code) {
      await this.$store.dispatch('setBranchCode', this.$route.params.branch_code);
    }
    const paramsWithTableCode = {
      ...this.$route.params,
      table_code: this.$route.params.table_code || this.$route.query.table_code || sessionStorage.getItem('TABLE_CODE') || '',
    };
    this.prefixUrl = await this.$store.dispatch('prefixUrl', paramsWithTableCode);
    const token = this.$route.query.token ?? null;
    const key = this.$route.query.key ?? null;
    const tokenLocal = TokenService.getLocalAccessToken();

    // M920: on a QR entry the branch's QR setting decides where the shopper starts, so
    // this view must not push anywhere. App.vue has already routed the other options
    // (this view only mounts once its /check-merchant-and-branch call answered, so a push
    // here would cancel that navigation and win), and "Landing Page" means staying here.
    if(!key && !token && !this.isSalonTheme && !this.qrRedirectOwnsRouting && this.branch?.show_landing_page_on_ordering_online == 0) {
      router.push(this.prefixUrl + "/order");
    }

    if(key) {
      if(tokenLocal) {
        router.push(this.prefixUrl + "/category");
      } else {
        this.handleLoginByPhoneAndPasscode(key);        
      }
    }

    if (token) {
      this.handleLoginToken(token);
    }
  },
  mounted() {
    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
    setTimeout(() => {
      this.isWaitingTime = false;
    }, 3000);
    const key = this.$route.query.key ?? null;
    if(!key) {
      // $(".btn-show-voucher-available-modal").click();
    }
    if (this.merchantCode && this.branchCode) {
      this.getSlides();
    }
  },
  computed: {
    // SH001 — "Theme for Salon" on the sale channel (minty_branches.salon_theme).
    isSalonTheme() {
      return Number(this.branch && this.branch.salon_theme) === 1;
    },
    isQrEntry() {
      return String(this.$route.params.type || "").toUpperCase() === "QR";
    },
    // 0 means the branch (or the setting) is not known yet — fall back to the old flag.
    qrRedirectPage() {
      const value = Number(this.branch && this.branch.moo_qr_redirect_page);
      return Number.isFinite(value) && value > 0 ? value : 0;
    },
    // M920: a QR scan follows the QR setting and nothing else. "Show Landing page on
    // Online Ordering page" still governs shoppers arriving through a plain MOO link.
    qrRedirectOwnsRouting() {
      return this.isQrEntry && this.qrRedirectPage > 0;
    },
    showLandingPage() {
      if (this.qrRedirectOwnsRouting) {
        return this.qrRedirectPage === QR_REDIRECT_LANDING_PAGE;
      }

      return !!(this.branch && this.branch.show_landing_page_on_ordering_online);
    },
    styleObject() {
      return {
        "--color": this.$store.state.mainThemeColorTheme2
          ? this.$store.state.mainThemeColorTheme2
          : this.$store.state.color,
      };
    },
    buttonColorTheme2() {
      return (
        this.$store.state.primaryButtonColorTheme2 ||
        this.$store.state.mainThemeColorTheme2 ||
        this.$store.state.color
      );
    },
    loaderLogo() {
      return this.$store.state.logoTheme2 ? this.$store.state.logoTheme2 : defaultLogo;
    },
    loaderAccent() {
      return this.$store.state.mainThemeColorTheme2
        || this.$store.state.color
        || "#f9dd4b";
    },
    brandName() {
      return localStorage.getItem(localStorageName("MERCHANT_BRAND_NAME")) || "";
    },
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    gotoSlide() {
      this.isWaitingTime = false;
    },

    gotoCategory() {
      this.$router.push(this.prefixUrl + "/category");
    },

    handleLoginToken(token) {
      var _this = this;
      _this.closeSnackbar();
      _this.isLoggingIn = true;
      _this.showLoader();
      _this.$store.dispatch("auth/loginToken", token).then(
        (data) => {
          if (data != undefined && !data.result.isSuccess) {
            this.hideLoader();
            _this.isLoggingIn = false;
            _this.message = data.result.message;
            _this.showSnackbarError();
          } else {
            router.push(this.prefixUrl);
          }
          _this.hideLoader();
        },
        (error) => {
          _this.isLoggingIn = false;
          _this.hideLoader();
          console.log("ERROR" + error);
        }
      );
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    showSnackbarError() {
      this.snackbar = "danger";
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    handleLoginByPhoneAndPasscode(data) {
      this.isLoggingIn = true;
      this.showLoader();
      const from = (this.$route.query.from ?? "").toLowerCase();
      const queue = this.$route.query.queue ?? false;
      var token = data;
      const memberId = this.$route.query.memberId ?? null;

      let dataForm = {
        memberId: memberId
      };

      // Store the fresh key first so the request interceptor attaches it as Bearer,
      // instead of a stale/invalid token left in localStorage (which causes a 401
      // redirect loop between member sign-in and online ordering)
      localStorage.setItem(localStorageName('token'), token);

      AuthService.getMemberInfo(dataForm, this.$route.params.merchant_code || this.$store.state.merchantCode || '').then(
          (response) => {
              if (response.data.result.isSuccess) {
                localStorage.setItem(localStorageName('token'), token);
                localStorage.setItem(localStorageName('memberInfo'), JSON.stringify(response.data.data.user));
                localStorage.removeItem(localStorageName('ORDER_ID_NON_MEMBER'));
                if(from && from == "myreward") {
                  router.push(this.prefixUrl + "/my-reward");
                } else if (from && from == "mycart") {
                  router.push(this.prefixUrl + "/my-cart" + (queue ? "?queue=true" : ""));
                } else if (from && from == "profile") {
                  router.push(this.prefixUrl + "/profile" + (queue ? "?queue=true" : ""));
                } else if (from && from == "order") {
                  router.push(this.prefixUrl + "/order");
                } else {
                  router.push(this.prefixUrl + "/category");
                }
              } else {
                  localStorage.removeItem(localStorageName('token'));
                  this.snackbar = "danger";
                  this.message = response.data.result.message;
                  this.setTimeOutNotification();
                  this.isLoggingIn = false;
                  this.hideLoader();
              }
              this.isLoadDone = true;
          },
          (error) => {
              localStorage.removeItem(localStorageName('token'));
              this.snackbar = "danger";
              this.message = error;
              this.isLoggingIn = false;
              this.hideLoader();
          }
      );
      // var _this = this;
      // _this.closeSnackbar();
      // _this.showLoader();
      // _this.$store.dispatch("auth/loginToken", token).then(
      //   (data) => {
      //     if (data != undefined && !data.result.isSuccess) {
      //       this.hideLoader();
      //       _this.message = data.result.message;
      //       _this.showSnackbarError();
      //     } else {
      //       localStorage.setItem("token", token);
      //       localStorage.setItem("memberInfo", JSON.stringify(data.data.user));
      //       router.push(this.merchantCode + this.branchCode+"/order");
      //     }
      //     _this.hideLoader();
      //   },
      //   (error) => {
      //     console.log("ERROR" + error);
      //   }
      // );

      
      // var _this = this;
      // _this.closeSnackbar();
      // _this.showLoader();
      // _this.$store.dispatch("auth/loginToken", token).then(
      //   (data) => {
      //     if (data != undefined && !data.result.isSuccess) {
      //       this.hideLoader();
      //       _this.message = data.result.message;
      //       _this.showSnackbarError();
      //     } else {
      //       localStorage.setItem("token", token);
      //       localStorage.setItem("memberInfo", JSON.stringify(data.data.user));
      //       router.push(this.merchantCode + this.branchCode+"/order");
      //     }
      //     _this.hideLoader();
      //   },
      //   (error) => {
      //     console.log("ERROR" + error);
      //   }
      // );


      // let result = JSON.parse(this.decryptData(data));
      // var _this = this;
      // _this.closeSnackbar();
      // _this.showLoader();
      // _this.$store.dispatch("auth/loginByPhoneAndPasscode", result).then(
      //   (data) => {
      //     if (data != undefined && !data.result.isSuccess) {
      //       this.hideLoader();
      //       _this.message = data.result.message;
      //       _this.showSnackbarError();
      //     } else {
      //       router.push(this.merchantCode + this.branchCode+"/order");
      //     }
      //     _this.hideLoader();
      //   },
      //   (error) => {
      //     console.log("ERROR" + error);
      //   }
      // );
    },

    decryptData(encryptedData) {
        if (encryptedData) {
            try {
                const decryptedData = CryptoJS.AES.decrypt(atob(encryptedData), process.env.VUE_APP_KEY_DECRYPT_MEMBER_INFORMATION).toString(CryptoJS.enc.Utf8);
                return decryptedData;
            } catch (error) {
                return "";
            }
        }
    },

    getSlides() {
      // if(this.memberInfo) {
        // console.log(this.memberInfo);
        this.showLoader();
        var dataForm = {
          isMintyApi: true,
          branch_code: this.branchCode,
          where_showing: 4,
          is_ordering_online: 1
        }
        OrderService.getSlidesLandingPage(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.slidesLandingPage = response.data.data
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.isLoadDone = true;
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
          }
        );
      // }
    },
  },
};
</script>

<style scoped>
/* MTH004 — branded login-callback loader (theme2) */
.mlx-login-loader {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 24px;
}
.mlx-ll-logo {
  width: 84px;
  height: 84px;
  border-radius: 18px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
}
.mlx-ll-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.mlx-ll-brand {
  font-weight: 800;
  font-size: 22px;
  letter-spacing: -0.02em;
  color: #201a1a;
}
.mlx-ll-spinner {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 4px solid;
  border-color: var(--mlx-accent, #f9dd4b) transparent transparent transparent;
  animation: mlx-ll-spin 0.9s linear infinite;
  margin-top: 6px;
}
.mlx-ll-text {
  font-size: 14px;
  font-weight: 600;
  color: var(--mlx-accent);
}
@keyframes mlx-ll-spin {
  to {
    transform: rotate(360deg);
  }
}
/* MTH009 — theme2 landing hero carousel */
.mlx-landing {
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  /* MTH107: 100vh on mobile Safari/Chrome is the chrome-hidden height, so the
     bottom of the hero sits below the visible area. svh (small viewport) is the
     chrome-shown height, which always fits; the 100vh line above it is the
     fallback for browsers that don't know svh. */
  min-height: 100vh;
  min-height: 100svh;
  background: #000;
  cursor: pointer;
}
.mlx-landing-hero {
  position: relative;
  width: 100%;
  min-height: 100vh;
  min-height: 100svh;
  overflow: hidden;
}
.mlx-landing-swiper,
.mlx-landing-swiper .swiper-slide {
  height: 100vh;
  height: 100svh;
}
.mlx-landing-img {
  width: 100%;
  height: 100vh;
  height: 100svh;
  object-fit: cover;
}
.mlx-landing-fallback {
  position: absolute;
  inset: 0;
}
.mlx-landing-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.45) 0%,
    rgba(0, 0, 0, 0) 30%,
    rgba(0, 0, 0, 0) 52%,
    rgba(0, 0, 0, 0.8) 100%
  );
}
.mlx-landing-brand {
  position: absolute;
  top: 44px;
  left: 24px;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 12px;
}
.mlx-landing-logo {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
  background: #fff;
}
.mlx-landing-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.mlx-landing-brand-name {
  color: #fff;
  font-weight: 800;
  font-size: 20px;
  letter-spacing: -0.02em;
}
.mlx-landing-pagination {
  /* MTH107: fixed (not absolute) so the dots ride the visible viewport bottom
     together with the CTA, whatever the browser chrome is doing. */
  position: fixed;
  bottom: calc(108px + env(safe-area-inset-bottom, 0px));
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  padding: 0 24px;
  z-index: 5;
  display: flex;
  gap: 6px;
}
.mlx-landing-pagination :deep(.swiper-pagination-bullet) {
  height: 4px;
  width: 6px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.4);
  opacity: 1;
  transition: width 0.3s ease;
}
.mlx-landing-pagination :deep(.swiper-pagination-bullet-active) {
  width: 24px;
  background: #fff;
}
.mlx-landing-cta {
  /* MTH107: the "Order now" button is pinned to the bottom of the visible
     viewport so it is reachable on every phone without scrolling; the safe-area
     inset keeps it clear of the iPhone home indicator. */
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  padding: 0 24px calc(32px + env(safe-area-inset-bottom, 0px));
  z-index: 5;
}
.mlx-landing-cta :deep(.mlx-landing-btn) {
  border: none !important;
  font-weight: 700;
  font-size: 18px;
  padding: 16px;
  border-radius: 16px !important;
  text-transform: none !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}
.page-header {
  position: relative;
  background-color: var(--color);
  padding-bottom: 0 !important;
}

.page-header .merchant-logo {
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 45%;
  transform: translate(0, -50%);
  z-index: 1;
}

.page-header .container {
  color: #222 !important;
  margin-top: calc(100vh - 300px);
}

.page-header .container .outlet-name {
  font-size: 28px;
}

.page-header .order-now {
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 80%;
  transform: translate(0, -50%);
  z-index: 1;
}

.page-header .order-now .btn {
  background: #ffffff;
  color: #222;
  border-radius: 5px;
  padding: 7px 50px;
  font-size: 12px;
  text-transform: unset !important;
}

.btn-start-ordering {
  width: 300px;
  margin-top: 12vh;
  font-size: 24px;
  font-weight: 500;
  line-height: 28px;
  background: none !important;
  border: 1px solid #222 !important;
  box-shadow: none !important;
  border-radius: unset !important;
}

.estimated-waiting-time {
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
}

.slider,
.slider img {
  width: 100%;
  height: 100vh;
}
</style>
